
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPanelLeftClose as ObiPanelLeftCloseElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-panel-left-close.js';
 
 
 

 
 export const ObiPanelLeftClose = createComponent({
   react: React,
   tagName: 'obi-panel-left-close',
   elementClass: ObiPanelLeftCloseElement,
   events: {
     
   }
  });
 
 